import React from "react";
import '../styles/Home.css';
import '../styles/global.css';
import { Link } from "react-router-dom";

function Home() {
    return (
        <div className="home-page">
            <div className="h-main-section">
                <h1 className="h-heading">NY Green Card EXAM - Quality Medical Onc PC.</h1>
                <div className="desc">
                    Hua Huang MD, is a USCIS Designated Civil Surgeon with over 10 years of experience of doing green card medical exams. 
                    We provide <em><b>high quality, efficient and low cost</b></em> immigration medical exams. 
                    You can find us on the <a className="link" href="https://www.uscis.gov/tools/find-a-civil-surgeon" target="blank">USCIS website ↗</a> using the address: 
                    136-30 Maple Avenue, Flushing, NY 11355 and find "Quality Medical Onc PC."
                    </div>
                    <div className="desc">
                    <br></br>
                    USCIS  immigration medical exams Form I-693 can be completed in 2-4 business days. <br></br>
                    Walk-ins welcome (appointment is encouraged; please call ahead for more info).
                    <br></br>
                    Please see the <Link className="int-link" to='/instructions'>Instructions</Link> tab for more info.
                </div>
                <h3 className="heading3">我们说中文!</h3>
                <h2 className="heading2">Contact</h2>
                <div className="contact-desc">
                    <div className="contact1">
                        <b>Phone:</b> (718) 353-8882<br></br>
                        <b>Address:</b> 136-30 Maple Ave, Suite 2A, Flushing, NY 11355<br></br><br></br>
                        Conveniently located in downtown Flushing, and easily accessible by the #7 train and buses. <br></br><br></br>
                        <b>Office Hours:</b>
                        <ul className="hours">
                            <li>Monday: 10 AM - 5 PM</li>
                            <li>Tuesday: 10 AM - 5 PM</li>
                            <li>Wednesday: Closed</li>
                            <li>Thursday: 10 AM - 5 PM</li>
                            <li>Friday & Saturday: By appointment</li>
                            <li>Sunday: Closed</li>
                        </ul>
                    </div>
                    <div className="contact2">
                        <iframe className ="map" 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2902314323483!2d-73.82916268486676!3d40.755640879327125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26013ad986c3f%3A0x830608b1f79cba14!2s136-30%20Maple%20Ave%2C%20Flushing%2C%20NY%2011355!5e0!3m2!1sen!2sus!4v1679023145453!5m2!1sen!2sus" 
                            allowfullscreen="" loading="lazy" title="Map" referrerpolicy="no-referrer-when-downgrade">
                        </iframe>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default Home;